import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import GlobalHeader from '../../components/Common/GlobalHeader';
import DeploymentActivityTable from '../../components/Dashboard/DeploymentActivityTable';
import './dashboard.css';

const Dashboard = () => {
  const { user } = useAuth();

  return (
    <div className="dashboard-wrapper">
      <GlobalHeader />
      <main className="dashboard-content">
        <header className="dashboard-header">
          <div className="header-welcome">
            <h1>Welcome, {user?.email?.split('@')[0]}</h1>
          </div>
          <div className="header-actions">
            <button className="btn-secondary" onClick={() => window.location.href = '/admin'}>Admin Control</button>
          </div>
        </header>

        <section className="activity-section">
          <DeploymentActivityTable />
        </section>
      </main>
    </div>
  );
};

export default Dashboard;
